// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"edge-in-selling_sectionWrapper__O5_JX","section":"edge-in-selling_section__OHRWY"};